export const Messages = {
    PAYMENT_VISIBILITY: (date) =>
        `Data before ${date} is not accessible. Please contact our support team at info@datman.je.`
};
